import BLoading from './BLoading';
export default BLoading;
